import { MillenniumDateTime } from "@timeedit/millennium-time";
import { TQueryFieldRef, TQueryTime } from "../types/api/APIParameterTypes";
import { TRef } from "../types/api/shared";

/** A query may name a field by id or by whole object; the server wants the id. */
export const toFieldId = (field: TQueryFieldRef) =>
    typeof field === "object" && field.id ? field.id : field;

/** findEntries is given dates, one or many, and sends Millennium timestamps. */
export const toMtsList = (times: TQueryTime | undefined) =>
    (Array.isArray(times) ? times : [times]).map((time) => (time as MillenniumDateTime).getMts());

/** Preferences are cached per key, per objects they are read for, and per user. */
export const getPrefsKey = (
    key: string,
    refs: (number | string | TRef)[] | undefined,
    language: string | undefined,
    isCurrentUser: boolean
) => `${key}:${JSON.stringify(refs)}:${String(language)}:${String(isCurrentUser)}`;

/**
 * A preference is stored as strings. A single empty one means unset, and
 * "true"/"false" are booleans, unless the preference is read per object, where
 * the list is kept as it is.
 */
export const parsePrefsValues = (values: string[], refs?: number[] | TRef[]) => {
    if (values.length === 1 && values[0] === "") {
        return null;
    } else if (refs) {
        return values;
    } else if (values[0] === "true") {
        return true;
    } else if (values[0] === "false") {
        return false;
    }
    return values[0];
};

/** As parsePrefsValues, for getPreferencesMulti, which answers with bare strings too. */
export const parsePrefValue = (value: string | string[]) => {
    let outValue;
    if (value.length === 1 && value[0] === "") {
        outValue = null;
    } else if (value.length === 1 && value[0] === "true") {
        outValue = true;
    } else if (value.length === 1 && value[0] === "false") {
        outValue = false;
    } else if (value === "true") {
        outValue = true;
    } else if (value === "false") {
        outValue = false;
    } else {
        outValue = value;
    }
    return outValue;
};
